import { TextField } from '@material-ui/core'
import React from 'react'
import InputMask from 'react-input-mask'
import { TextValidator } from 'react-material-ui-form-validator'
import { useSelector } from 'react-redux'

const onlyDigits = value => (value || '').replace(/[^\d]/g, '')

// Formato por país (nacional, sem DDI): a máscara a partir dos dígitos e o padrão que o
// texto mascarado precisa seguir para estar completo. País desconhecido usa o do BR
const FORMATS = {
  BR: {
    // Alterna entre fixo e celular pela quantidade de dígitos
    mask: digits =>
      digits.length <= 10 ? '(99) 9999-9999?' : '(99) 99999-9999',
    pattern: '^\\(\\d{2}\\) \\d{4,5}-\\d{4}$',
  },
  US: {
    mask: () => '(999) 999-9999',
    pattern: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
  },
  PY: {
    // Celular começa com 09; fixo tem prefixo de área de 3 dígitos com o 0
    mask: digits =>
      digits.startsWith('09') ? '9999 999 999' : '(999) 999 999?',
    pattern: '^(09\\d{2} \\d{3} \\d{3}|\\(\\d{3}\\) \\d{3} \\d{3,4})$',
  },
  ES: {
    mask: () => '999 999 999',
    pattern: '^\\d{3} \\d{3} \\d{3}$',
  },
}

// Telefone com máscara no formato do país: o da prop `country` ou, sem ela, o da lavanderia.
// onChange e onBlur recebem o evento do input como ele é (valor mascarado): limpar para
// dígitos antes de gravar fica com quem usa. onVerify recebe os dígitos.
// Com `validate`, vira TextValidator (precisa estar num ValidatorForm) e mostra "Telefone
// inválido" quando o número não segue o formato do país; `validators` e `errorMessages`
// extras entram depois dessa regra. Props extras (name, label...) vão para o campo
const PhoneField = ({
  value,
  onChange,
  onBlur,
  onVerify,
  country,
  validate = false,
  validators = [],
  errorMessages = [],
  ...rest
}) => {
  const tenantCountry = useSelector(
    state => state.auth.tenantLocale?.country?.code
  )
  const format = FORMATS[country || tenantCountry] || FORMATS.BR

  const handleBlur = e => {
    if (onVerify) onVerify(onlyDigits(e.target.value))
    if (onBlur) onBlur(e)
  }

  return (
    <InputMask
      mask={format.mask(onlyDigits(value))}
      formatChars={{ 9: '[0-9]', '?': '[0-9 ]' }}
      maskChar=""
      value={value || ''}
      onChange={onChange}
      onBlur={handleBlur}
    >
      {inputProps =>
        validate ? (
          <TextValidator
            {...inputProps}
            {...rest}
            validators={[`matchRegexp:${format.pattern}`, ...validators]}
            errorMessages={['Telefone inválido', ...errorMessages]}
          />
        ) : (
          <TextField {...inputProps} {...rest} />
        )
      }
    </InputMask>
  )
}

export default PhoneField
